import Legacy from '../views/Legacy'

export default Legacy
